(function($){
  $(document).ready(function() {

    var siteheader = $("body:not(.admin) .site-header");
    var menuOffset = siteheader.outerHeight() + 30;

    var duration = 500;
    if ($('body').hasClass('admin')) {
        duration = 0;
        menuOffset = $(".adminPanel").outerHeight() + 30;
    }
    $.localScroll({
        duration: duration,
        hash: true,
        offset: -menuOffset,
    });

    var c, currentScrollTop = 0;
    $(window).scroll(function () {
        var a = $(window).scrollTop();
        var b = siteheader.outerHeight();
        // var b = siteheader.height();

        currentScrollTop = a;

        if (c < currentScrollTop && a > b + b) {
            siteheader.addClass("scrollUp");
        } else if (c > currentScrollTop && !(a <= b)) {
            siteheader.removeClass("scrollUp");
        }
        c = currentScrollTop;
    });

    $('[data-js="no-link"]').on('click', function(e){
        e.preventDefault();
    })

    $('body').on('mouseover','.menu_item, .outil-item', function(){
        $(this).siblings().removeClass('hover');
        $(this).addClass('hover');
    });
    $('body').on('mouseout', '.menu_item, .outil-item', function(){
        $(this).removeClass('hover');
    });

    var masque = $('<div class="masque" tabindex="1">').appendTo('body');
    masque.on('click', function(){
        close_all();
    });

    var menuToggle = $('#site-menu-toggle'),
        menu = $(menuToggle.data('target'));

    menuToggle.click(function(e) {
        e.preventDefault();
        masque.toggle();
        menuToggle.toggleClass('is-active');
        $('body').toggleClass('menu-open');
        menu.toggleClass('open');
        menu.find('.current').addClass('open');
    });



    $('.panier .menu_link').on('click', function(){
        close_all();
    });

    function close_all() {
        $('.menu-recherche').removeClass('open');
        masque.hide().attr("class", "masque" );
        menu.removeClass('open');
        $('body').removeClass('menu-open');
        menuToggle.removeClass('is-active');
        fermer_popin();
    }

    var keys={'esc': 27, 'left': 37, 'right': 39}
    $(document).on("keydown", function(e) {
        switch(e.keyCode){
            case keys.esc:
                e.preventDefault();
                close_all();
            break;
        }
    });



  })
})(jQuery);



var timeout    = 200;
var closetimer = 0;
var ddmenuitem = 0;
function MenuDeroulant_open(){
    MenuDeroulant_canceltimer();
    MenuDeroulant_close();
    ddmenuitem = $(this).find('.sousmenuH').css('visibility', 'visible');
}
function MenuDeroulant_close(){
    if(ddmenuitem)
        ddmenuitem.css('visibility', 'hidden');
}
function MenuDeroulant_timer(){
    closetimer = window.setTimeout(MenuDeroulant_close, timeout);
}
function MenuDeroulant_canceltimer(){
    if (closetimer){
        window.clearTimeout(closetimer);
        closetimer = null;
    }
}
function ThisMenuDeroulant_open(name){
    ddmenuitem = $('#'+name).css('visibility', 'visible');
}

function afficher_recherche(site){
    $('html, body').delay(200).animate({scrollTop:0}, 'fast');
    $.ajax({
        url: 'inc/xhr/actions.php?action=recherche&site='+site,
        success: function(data){
            ouvre_popinnoir(data);
        }
    });
}

function fermer_popin(){
    $("#popin").html("");
    $("#popin").hide();
    $("#contpopinnoir").html("");
    $("#popinnoir").hide();
    $("#minipopin .container").html("");
    $("#minipopin").hide();
}

function ouvre_popinnoir(data){
    var posScroll = parseInt($(document).scrollTop());
    var popin_content = "<div style=\"height: "+posScroll+"px;width:100%\"></div><div style=\"float:right;\"><a class=\"fermer\" href=\"javascript:fermer_popin()\"><img src=\"images/env/b_fermer.png\" border=\"0\" \></a></div><div style=\"padding-top: 0px;\"> " + data + "</div>";
    $("#contpopinnoir").html(popin_content); // ON AFFICHE LA REPONSE
    $("#contpopinnoir").css("height",$("body").height()+"px");
    $("#popinnoir").show();
}

function ouvre_popin(data){
    $("#popin .container").html(data); // ON AFFICHE LA REPONSE
    $("#popin").show();

    var left = ($(window).width() - $("#popin").width())/2;
    var posScroll = parseInt($(document).scrollTop());

    $("#popin").css('top',(posScroll+150)+'px');
    $("#popin").css('left',left+'px');

    $('.tableauborder tbody').each(function(){
        $('tr:has(td):odd', this).addClass('trgris');
    });
}

function ouvre_minipopin(data){
    $("#minipopin .container").html(data); // ON AFFICHE LA REPONSE
    $("#minipopin").show();
}

function ouvre_popin_responsive(data){
    $("#popin .container").html(data); // ON AFFICHE LA REPONSE
    $("#popin").show();

    // var left = ($(window).width() - $("#popin").width())/2;
    var posScroll = parseInt($(document).scrollTop());

    $("#popin").css('top',(posScroll+150)+'px');
}
